export default __webpack_public_path__ + "static/media/51.79526527.jpg";